<template>
  <div v-if="question != null">
    <!-- <v-runtime-template :template="question"></v-runtime-template> -->
    <!-- <vue-plyr class="mb-3" :options="videoControls">
      <video src="https://media.vued.vanthink.cn/sparkle_your_name_am720p.mp4">
        <source
          src="https://media.vued.vanthink.cn/sparkle_your_name_am720p.mp4"
          type="video/mp4"
          size="720"
        />
      </video>
    </vue-plyr>-->
    <!-- <video id="player" controls style="width:100%; height:100%">
      <source :src="question.audio" type="application/x-mpegURL" />
    </video>-->

    <!-- <vue-plyr class="mb-3" :options="videoControls" v-if="question.video!==''">
      <video :src="question.video">
        <source
          :src="question.video"
          type="application/x-mpegURL"
          size="720"
        />
      </video>
    </vue-plyr>-->

    <!-- <v-card class="my-3">
      <v-card-text class="pa-3">
        ชื่อไฟล์เสียง
      </v-card-text>
      <v-divider></v-divider>
      <v-card-text class="pa-1">
        <vue-plyr :options="audioControls">
          <audio>
            <source
              src="http://file-examples.com/wp-content/uploads/2017/11/file_example_MP3_1MG.mp3"
              type="audio/mp3"
            />
          </audio>
        </vue-plyr>
      </v-card-text>
    </v-card>-->
    <!-- <iframe
      v-if="question.audio!==''"
      :src="`https://fleet.byteark.com/player?url=${question.audio}`"
      class="resonsive-iframe"
      width="100%"
      height="250"
      frameborder="0"
      allowfullscreen
    ></iframe>-->

    <!-- <div>
      จากบทความ
    </div>-->

    <!-- <v-alert
      icon="far fa-question-square"
      text
      border="left"
      color="info"
      colored-border
      dense
    >โจทย์คำถาม</v-alert>-->
    <!-- <div class="my-3" v-if="question.articleQuestion == null">
      <div class="question">
      <div class="text-center currentQuestion">คำถามข้อที่ {{indicator}} </div>
      <div class="text-center score">( {{question.score}} คะแนน)</div>
      </div>
    </div>-->

    <div class="mb-6 pb-4 summary">
      <h2 class="text-center currentQuestion">คำถามข้อที่ {{ indicator }}</h2>
      <p class="text-center subtitle">( {{ question.score }} คะแนน )</p>
    </div>

    <div
      class="mb-10"
      v-if="question.audio != null && question.audio != ''"
      id="audio-container"
    >
      <div class="article-title mb-2">จากคลิปเสียง</div>
      <!-- <template v-if="platform == 'ios'">
        <v-sheet rounded color="grey lighten-4" class="pa-2" outlined>
          <div class="d-flex">
            <div class="flex-shrink-1">
              <v-btn
                text
                v-show="audioState == 0 || audioState == 2"
                small
                color="primary"
                @click="mediaControl('playAudio')"
              >
                <v-icon left>fas fa-play</v-icon>
                {{ audioState == 0 ? "เล่นคลิปเสียง":"เล่นต่อ" }}
              </v-btn>
              <v-btn
                text
                v-show="audioState == 1"
                small
                color="green"
                @click="mediaControl('pauseAudio')"
              >
                <v-icon left>fas fa-pause</v-icon>หยุดชั่วคราว
              </v-btn>
            </div>
            <v-spacer></v-spacer>
            <div class="flex-shrink-1">
              <v-btn
                color="error"
                small
                icon
                v-show="audioState != 0"
                @click="mediaControl('stopAudio')"
              >
                <v-icon>fas fa-stop</v-icon>
              </v-btn>
            </div>
          </div>
          <template v-if="audioState == 2">
            <div class="ml-2 caption info--text">* หยุดเล่นคลิปเสียงชั่วคราว</div>
          </template>
        </v-sheet>
      </template>
      <template v-else>
        <iframe
          v-if="question.audio!==''"
          :src="`https://fleet.byteark.com/player?url=${question.audio}`"
          class="resonsive-iframe"
          width="100%"
          height="60"
          frameborder="0"
          allowfullscreen
        ></iframe>
      </template>-->

      <!-- <div id="audio"></div> -->
      <!-- <audio :src="'http://file-examples.com/wp-content/uploads/2017/11/file_example_MP3_1MG.mp3'"></audio> -->
      <v-sheet rounded style="border: 1px solid #d3d3d3; padding: 4px">
        <vue-plyr :options="audioControls">
          <audio>
            <source :src="question.audio" type="audio/mp3" />
          </audio>
        </vue-plyr>
      </v-sheet>
    </div>

    <div class="mb-6" v-if="question.video != null && question.video != ''">
      <p class="article-title mb-2">จากวิดิโอ</p>
      <!-- <div id="video"></div> -->
      <!-- <iframe
        v-if="question.video !== '' && question.video !== 'antMedia'"
        :src="`https://fleet.byteark.com/player?url=${question.video}`"
        class="resonsive-iframe"
        width="100%"
        height="250"
        frameborder="0"
        allowfullscreen
      ></iframe> -->
      <VideoPlayer v-if="question.video !== ''" :url="question.video" />
      
      <!-- <template v-if="platform == 'ios'">
        <v-sheet rounded color="grey lighten-4" class="pa-2" outlined>
          <div class="d-flex">
            <div class="flex-shrink-1">
              <v-btn text small color="primary" @click="mediaControl('openVideoPlayer')">
                <v-icon left>fas fa-play</v-icon>เล่นวีดีโอ
              </v-btn>
            </div>
            <v-spacer></v-spacer>
          </div>
        </v-sheet>
      </template>
      <template v-else>
        <iframe
          v-if="question.video!==''"
          :src="`https://fleet.byteark.com/player?url=${question.video}`"
          class="resonsive-iframe"
          width="100%"
          height="250"
          frameborder="0"
          allowfullscreen
        ></iframe>
      </template>-->
    </div>

    <div class="mb-6" v-if="question.articleQuestion != null">
      <p class="subtitle mb-4">จากบทความ</p>
      <!-- <v-alert icon="far fa-book" text border="left" color="info" colored-border dense>บทความ</v-alert> -->
      <div
        class="article-content"
        v-html="question.articleQuestion.article"
        ref="articleContainer"
        id="articleContainer"
      ></div>

      <!-- <v-divider class="mb-3"></v-divider> -->
    </div>
    <!-- <p class="subtitle" v-if="question.typeQuestion != 'matchsome'">จงตอบคำถามต่อไปนี้</p>
    <p
      class="subtitle"
      v-if="question.typeQuestion == 'matchsome'"
    >จง "เลือกคู่" ให้ตรงกับคำถามต่อไปนี้</p>-->
    <div
      v-html="question.question"
      class="question mb-4"
      ref="questionContainer"
      id="questionContainer"
    ></div>

    <v-overlay :value="overlay">
      <pinch-zoom v-bind:properties="myProperties">
        <img :src="imgPinch" />
      </pinch-zoom>
      <v-btn class="ma-2 btn-close" fab dark small @click="overlay = false">
        <v-icon>far fa-times</v-icon>
      </v-btn>
    </v-overlay>
  </div>
</template>

<script>
// import VRuntimeTemplate from "v-runtime-template";
import EventBus from "@/event-bus";
import PinchZoom from "vue-pinch-zoom";
import VideoPlayer from "@/components/VideoPlayer.vue";
const videoControls = {
  controls: ["play-large", "play", "current-time", "fullscreen"],
};
const audioControls = {
  controls: ["play", "progress", "current-time"],
};
export default {
  components: {
    PinchZoom,
    VideoPlayer
  },
  props: ["question", "indicator"],
  data: () => ({
    audioControls,
    videoControls,
    overlay: false,
    myProperties: {
      overflow: "visible",
    },
    imgPinch: null,
    audioState: 0,
  }),
  computed: {
    platform() {
      let pf = this.$route.query.platform || "web";
      return pf;
    },
  },
  mounted() {
    // console.log(this.question);
    // console.log("yes");
    // console.log(
    //   "width",
    //   document.getElementById("audio-container").style.width
    // );
    // this.question.video
    //   ? jwplayer("video").setup({
    //       // playlist: this.question.video
    //       // sources: [{file:"this.question.video",label:"SD",type: "video/mp4"},{file:"http://localhost/srt/43534234/viral022018HD.MP4",label:"HD",type: "video/mp4",default: true}],
    //       sources: [{ file: this.question.video }],
    //       mute:
    //         this.question.video !== "" && this.question.audio !== ""
    //           ? true
    //           : false,
    //       autostart:
    //         this.question.video !== "" && this.question.audio !== ""
    //           ? false
    //           : true,
    //       width: "100%",
    //     })
    //   : "";
    // this.question.audio
    //   ? jwplayer("audio").setup({
    //       // playlist: this.question.video
    //       // sources: [{file:"this.question.video",label:"SD",type: "video/mp4"},{file:"http://localhost/srt/43534234/viral022018HD.MP4",label:"HD",type: "video/mp4",default: true}],
    //       // sources: [{file:this.question.audio}],
    //       autostart: true,
    //       flashplayer: "player.swf",
    //       file: this.question.audio,
    //       // height: 60,
    //       autostart:
    //         this.question.video !== "" && this.question.audio !== ""
    //           ? false
    //           : true,
    //       mute:
    //         this.question.video !== "" && this.question.audio !== ""
    //           ? true
    //           : false,
    //       height: "40px",
    //       // width: "100%",
    //       // width: (screen.width - 24)
    //       width: document.getElementById("audio-container").style.width,
    //     })
    //   : "";

    // when DOM updated
    this.$nextTick().then(() => {
      // find img
      if (this.question.articleQuestion != null) {
        let imgs = this.$refs.articleContainer.querySelectorAll("img");
        for (let img of imgs) {
          // img.style.maxWidth = "100%";
          // img.style.height = "auto";
          img.addEventListener("click", (e) => {
            this.showOverlay(e);
          });
        }

        let links = this.$refs.articleContainer.querySelectorAll("a");
        for (let link of links) {
          // img.style.maxWidth = "100%";
          // img.style.height = "auto";
          link.addEventListener("click", (e) => {
            e.preventDefault();
            EventBus.$emit("internalBrowser", e.target.href);
          });
        }
      }

      // binding img click in question
      let imgsInQuestion = this.$refs.questionContainer.querySelectorAll("img");
      for (let img of imgsInQuestion) {
        // img.style.maxWidth = "100%";
        // img.style.height = "auto";
        img.addEventListener("click", (e) => {
          this.showOverlay(e);
        });
      }

      let linksInQuestion = this.$refs.questionContainer.querySelectorAll("a");
      for (let link of linksInQuestion) {
        // img.style.maxWidth = "100%";
        // img.style.height = "auto";
        link.addEventListener("click", (e) => {
          e.preventDefault();
          EventBus.$emit("internalBrowser", e.target.href);
        });
      }
    });
  },
  methods: {
    showOverlay(e) {
      this.imgPinch = e.target.src;
      this.overlay = true;
    },
    toggleFullscreen(e) {
      // console.log(e);

      if (!document.fullscreenElement) {
        e.target.requestFullscreen().catch((err) => {
          alert(
            `Error attempting to enable full-screen mode: ${err.message} (${err.name})`
          );
        });
      } else {
        try {
          document.exitFullscreen();
        } catch (error) {}
      }
    },
    mediaControl(cmd) {
      try {
        switch (cmd) {
          case "playAudio":
            if (typeof playAudio !== "undefined") {
              playAudio.postMessage(this.question.audio);
            }
            this.audioState = 1; // 1 is played
            break;
          case "pauseAudio":
            if (typeof pauseAudio !== "undefined") {
              pauseAudio.postMessage("pause");
            }
            this.audioState = 2; // 2 is pause
            break;
          case "stopAudio":
            if (typeof stopAudio !== "undefined") {
              stopAudio.postMessage("stop");
            }
            this.audioState = 0; // 0 is stop
            break;
          case "openVideoPlayer":
            if (typeof openVideoPlayer !== "undefined") {
              if (this.audioState != 0) {
                this.mediaControl("stopAudio");
              }
              openVideoPlayer.postMessage(this.question.video);
            }
            break;

          default:
            break;
        }
      } catch (error) {
        // do nothing
      }
    },
  },
};
</script>
<style scoped lang="scss">
.question {
  font-size: 1.25rem;
}

.article-content {
  padding: 16px;
  background: #f5f5f5;
  border-radius: 8px;
}
#articleContainer ::v-deep * img {
  max-width: 100%;
}

#questionContainer ::v-deep * img {
  max-width: 100%;
}

::v-deep .btn-close {
  position: fixed;
  top: 0px;
  right: 0px;
}
</style>